module.exports = __webpack_public_path__ + "img/panang_ready.f0836256.jpg";